<template>
    <div id="app-body-container" style="float:left" >      
      <!-- Hacky way to trigger computed dropfilesUpdate property to ensure the drag/drop works correctly -->
                <!-- TODO: One day find a better solution --> 
              <div style="display:none">{{dropFilesUpdate}}</div>
        
        <div v-if="!done" >
            <div  v-if="processingActive">
                <ProgressIndicator   :progress="progress" :label="$t('generic.compressing')" />
                
            </div>
            
             
            <div v-if="!processingActive">
                
                
                  <div v-if="!fileList" style="float:left;text-align:center">
                  <FileChooser v-if="!processingActive"                           
                                  is-multiple
                                  :is-add="false"
                                  @multiple-files-chosen="addFiles"
                                  accepted-extensions=""                             
                      />
                      <div><a href="#" v-on:click="emptyFileList()"  style="margin-left: -60px;">Start with empty</a></div>
                    </div>
                  

                  <EditFileList 
                                v-if="fileList"
                                :file-list="fileList" 
                                :edit-service="editService" 
                                :add-directory="addFolder"
                                :add-files="addFiles"
                                :remove-file="removeFile"
                                :set-current-dir="setCurrentDir"
                                @password-error="setPasswordError"  /> 

                  <div v-if="fileList && fileList.length > 0" class="mt-2" style="height: 50px;">
                    <button v-on:click="compressFiles()" class="float-end btn btn-primary btn-lg d-md-none">{{$t('ZIP.zip-files')}}</button>
                    <div class="float-end btn-group d-none d-md-inline" role="group" aria-label="zip files">
                        <button v-on:click="compressFiles()" type="button" class="btn btn-lg btn-primary">{{$t('ZIP.zip-files')}}</button><button id="compressionDrop" type="button" class="btn btn-lg btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                        <div class="dropdown-menu bg-primary" aria-labelledby="compressionDrop">
                                <a class="dropdown-item" @click="setCompression($event, 0)" v-bind:style="{ fontWeight: compressionLevel === 0? '900' : '100' }" href="#">{{ $t("generic.no-compression") }}</a>
                                <a class="dropdown-item" @click="setCompression($event, 4)" v-bind:style="{ fontWeight: compressionLevel === 4? '900' : '100' }" href="#" >{{ $t("generic.medium-compression") }}</a>
                                <a class="dropdown-item"  @click="setCompression($event, 9)" v-bind:style="{ fontWeight: compressionLevel === 9? '900' : '100' }" href="#" >{{ $t("generic.max-compression") }}</a>
                          </div>
                    </div>
                    <a href="/" class="float-end btn btn-secondary btn-lg me-2">{{$t('generic.reset')}}</a>
                  </div>
              </div>
        </div>
        <div v-if="done">
          <div class="form-group" v-if=" !uploading" >
                <h3 style="margin-top:0">{{ $t("generic.compressed")}}</h3>
                <p>{{ $t("generic.compressed-can-save")}}</p>
              </div>
              <div class="form-group" v-if=" uploading" >
                <h3 style="margin-top:0">{{ $t("generic.uploading-file")}} <img class="loading-svg" src="https://www.ezyzip.com/assets/images/loading.svg" alt="uploading"  ></h3>                
              </div>
              
              <div style="margin-top:40px" v-if="!uploading" class="form-group">
                <!--
                <button type="reset" class="btn btn-default btn-lg pull-left ng-fadeInLeft " v-on:click="reset">{{ $t("generic.reset")}}</button>
                -->
                <a :href="$t('page.pageRoute')" class="btn btn-default btn-lg pull-left ng-fadeInLeft" > {{ $t("generic.reset") }}</a>
                
                
                
                
                
                
                <button type="button" class="d-md-none btn btn-success btn-lg " v-on:click="saveFile">{{ $t("ZIP.save-zip") }}</button>
                 
                
                
                <div class=" btn-group d-none d-md-inline" role="group" aria-label="save zip files">
                        <button v-on:click="saveFile" type="button" class="btn btn-lg btn-success">{{ $t("ZIP.save-zip") }}</button><button id="compressionDrop" type="button" class="btn btn-lg btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                        <div class="dropdown-menu bg-success" aria-labelledby="compressionDrop">
                                <a class="dropdown-item" v-on:click="uploadToDropbox"  href="#"><i class="fab fa-dropbox"></i>&nbsp;Dropbox</a>                                
                          </div>
                    </div>
                
                
                
                
                
                
                
                
              </div>
        </div>
    </div>
</template>
<script>
import FileChooser from './ui/FileChooser.vue'
import { createFileListItem, gaEvent, saveFile } from '../services/Utils'
import EditService from '../services/EditService'
import EditFileList from './ui/EditFileList.vue'
import ProgressIndicator from './ui/ProgressIndicator.vue'
import DropboxService from '../services/DropboxService'


export default {
  name: 'NewArchive',
  props: {
    dropFiles: Object
  },  
  components: {
    FileChooser,
    EditFileList,
    ProgressIndicator    
  },
  data() {
       return {
         editService: new EditService(),
         loading: false,
         done: false,         
         fileSaved: false,
         processingActive: false,
         fileList: null,
         fileData: new Map(),
         processedFiles: false,
         zipBlob: null,
         progress: {currentFile: '', progress: 0},
         zipProgress: 0,
         currentFile: '',
         currentDir: '',
         compressionLevel: 9,
         uploading: false,
         lastDrop: {}
       };
     }, 
    computed: {
      dropFilesUpdate() {        
        // TODO: Maybe fix this hacky solution one day...?
        if (this.dropFiles && this.dropFiles.files) {
          if (this.lastDrop != this.dropFiles) {            
            this.addFiles(this.dropFiles, this.currentDir);
          }          
        }        
        return this.dropFiles;
      }
    }, 
    methods: {        
        setCurrentDir: function(newDir) {          
          this.currentDir = newDir;
        },
        removeFile: function(file) { 
            try {         
            if (file.isDirectory) {
              this.fileList = this.fileList.filter(f => !f.fullpath.startsWith(file.filename + '/')); //remove subdirectories and files              
            } 
            let fileNo = this.fileList.findIndex(f => f.filename === file.filename);
              
              if (fileNo >= 0) { // ensures the file is found in the array
                  this.fileList.splice(fileNo, 1);
              }
            } catch(ex) {
              console.log( ex);
              gaEvent( 'newArchive-removeFile-error', ex); 
              alert('An error occured');
            }
        },
        emptyFileList: function() {          
          this.fileList = [];
        },
        uploadToDropbox: async function() {
          // https://stackoverflow.com/questions/34399049/dropbox-direct-upload-files-from-browser
          if (!this.dropboxService) { // TODO: This isn't the right way to do it!!!!
              console.log('init dropboxService....');
              this.dropboxService = new DropboxService();
            }
          if (!this.dropboxService.isAuthenticated()) {              
              this.dropboxService.authenticate();
            } else {
              this.uploading = true;
              if (!this.dropboxService) {            
                this.dropboxService = new DropboxService();
              }
              
              // TODO: Add a timestamp to the ZIP file                  
              try {
                await this.dropboxService.uploadFile('ezyZip.zip', this.zipBlob );
                this.uploading = false;
                gaEvent( 'zipfiles-upload-dropbox', window.location.pathname); 
              } catch (ex) {
                alert('Error uploading file to Dropbox');
                this.uploading = false;
                gaEvent( 'zipfiles-upload-dropbox-error', window.location.pathname); 
              } 
              
              gaEvent( 'zipfiles-upload-dropbox', window.location.pathname); 
          }
      },        
       getProgress: function() {
         return this.zipProgress;
       },
       addFiles: function(e, dir) {
         // this.fileList = e.currentTarget.files;
         // console.log('current target', e.currentTarget);
         try {
         if (this.fileList == null) {
          this.fileList = [];
         }
         
         let currentDir = dir? dir + '/'  : '';
           Array.from(e.files).forEach(f => {              
              const fullpath = currentDir + f.name;
              this.fileList.push(createFileListItem(fullpath, false, f.size));              
              this.fileData.set(fullpath, f);
              
         });
         gaEvent( 'newArchive-changefiles', window.location.pathname);
         } catch(ex) {
          console.log( ex);
          gaEvent( 'newArchive-addFiles-error', ex); 
          alert('An error occured');
         }
       },
       addFolder: function(folderName) {
          
          this.fileList.unshift(createFileListItem(folderName, true, 0));          
       },
       changeFolder: function(e) {
         try {

           Array.from(e.currentTarget.files).forEach(f => {
              //let file = {name: 'filename', file: f};
              //console.log('f is', f);
              this.fileList.push(f);
              this.zipFile.file(f.webkitRelativePath, f);
         });
         gaEvent( 'newArchive-changefolder', window.location.pathname); 
         } catch(ex) {
          console.log( ex);
          gaEvent( 'newArchive-changeFolder-error', ex); 
          alert('An error occured');
         }
       },
       saveFile: function() {
        try {
         saveFile(this.zipBlob, 'ezyzip.zip');                         
         gaEvent('newArchive-savefile', window.location.pathname);
         } catch(ex) {
          console.log(ex);
          gaEvent( 'newArchive-saveFile-error', ex); 
          alert('An error occured');
         }
       },
       reset: function() {
         this.fileList = [];         
          this.loading= false;
          this.done = false;
          //this.zipFile= new JSZip();
          this.fileSaved= false;
          this.processingActive= false;
          this.processedFiles= false;
          this.zipBlob= null;
          this.compressionLevel = 9;
          this.zipProgress = 0;
       },
       setCompression: function(e, level) {
           this.compressionLevel = level;
           e.preventDefault();
           gaEvent('newArchive-level', level); 
       },
       createArchive: function() {
            console.log('Create archive!!');
       },
       compressFiles: async function() {
          try {
            if (this.fileList.length < 1) {
                return;
            }
            this.processingActive = true;
            const zip = window.zip; 
            const blobWriter = new zip.BlobWriter("application/zip");
            const zipWriter = new zip.ZipWriter(blobWriter, { bufferedWrite: true, useCompressionStream: false });
            
                    
            const fileCount = this.fileList.filter(f => !f.isDirectory).length;          
            let currentFileNo = 0;
            for (const file of this.fileList) {                
                const data = this.fileData.get(file.fullpath);         
                if (file.isDirectory) {                                                      
                  await zipWriter.add(file.fullpath + "/", new zip.TextReader(""), { level: this.compressionLevel, directory: true });
                }  else {
                  
                  this.progress.progress =  (currentFileNo / fileCount) * 100;                  

                  await zipWriter.add(file.fullpath, 
                                      new zip.BlobReader(data),  
                                      { level: this.compressionLevel, 
                                        onprogress: (progress, total) => {                                            
                                          let progressPercent = Math.floor((progress / total) * 100);
                                          this.progress.currentFile = file.fullpath + ' ' + progressPercent + '%';
                                        }    
                   });
                  currentFileNo++;
                }                      
            }
            await zipWriter.close();
            this.zipBlob = await blobWriter.getData();
            this.done = true;
          } catch(ex) {
            console.log(ex);
            gaEvent( 'newArchive-compressFiles-error', ex); 
            alert('An error occured');
          }
        }
    }
}
</script>
